'use client';
import { useEffect, useState } from 'react';

import { createSignedImageUrl } from '@utils/helpers/imageUploadHelpers';

/**
 * Custom hook for loading images with signed URLs
 */
export const useImage = (imagePath: string | null | undefined) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [imageLoading, setImageLoading] = useState(!!imagePath);

  useEffect(() => {
    const loadImage = async () => {
      // Reset states immediately when path changes
      setImageUrl(null);
      setImageLoading(true);

      if (!imagePath) {
        setImageLoading(false);
        return;
      }

      try {
        const signedUrl = await createSignedImageUrl(imagePath);
        setImageUrl(signedUrl);
        // If signedUrl is null, the image doesn't exist - this is handled gracefully
      } catch (error) {
        console.error('Failed to load image:', error);
        setImageUrl(null);
      } finally {
        setImageLoading(false);
      }
    };

    loadImage();
  }, [imagePath]);

  return { imageUrl, imageLoading };
};
